import { render, staticRenderFns } from "./cariDetay.vue?vue&type=template&id=9217006e&scoped=true&"
import script from "./cariDetay.vue?vue&type=script&lang=js&"
export * from "./cariDetay.vue?vue&type=script&lang=js&"
import style0 from "./cariDetay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cariDetay.vue?vue&type=style&index=1&id=9217006e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9217006e",
  null
  
)

export default component.exports